import { pipegoApi } from './createApi';


/**
 * API wrapper for Pipego service endpoints
 * @namespace pipego
 */
export const pipego = {
	getMessageHistory: async ( number, cursor = null ) => {
		if ( cursor ) {
			const response = await pipegoApi.get( `/chats/${number}?cursor=${cursor}` );
			return { messages: response.data.data, cursor: response.data.cursor, chat: response.data.chat };
		}
		const response = await pipegoApi.get( `/chats/${number}` );
		return { messages: response.data.data, cursor: response.data.cursor, chat: response.data.chat };
	},

	/**
	 * Sends a message using the API
	 * @async
	 * @function sendMessage
	 * @param {string} number Recipient's phone number
	 * @param {string} message Message content
	 * @param {string} operatorEmail Operator email
	 * @returns {Promise<Object>} Response data from the API
	 */
	async sendMessage( number, message, caseId = null, userId = null, userEmail = null, contactName = null ) {
		if ( caseId && userId && userEmail ) {
			const response = await pipegoApi.post( '/messages/send', {
				jid  : number,
				message,
				type : 'number',
				caseId,
				userId,
				userEmail,
				contactName,
			} );
			return response.data;
		}
		const response = await pipegoApi.post( '/messages/send', {
			jid  : number,
			message,
			type : 'number',
		} );
		return response.data;
	},

	/**
	 * Fetches chats for a specific operator by email
	 * @async
	 * @function getOperatorChats
	 * @param {string} email Operator email
	 * @returns {Promise<Object>} Response data from the API
	 */
	getOperatorChats: async ( cursor = null, selectedOperators = [], selectedDepartments = [], selectedShowOnlyBannedPhones = false ) => {
		if ( cursor ) {
			const response = await pipegoApi.get( '/chats', {
				params: {
					cursor,
					operators   : selectedOperators,
					departments : selectedDepartments,	
					showOnlyBannedPhones: selectedShowOnlyBannedPhones
				},
			} );
			return response.data;
		}
		const response = await pipegoApi.get( '/chats', {
			params: {
				operators   : selectedOperators,
				departments : selectedDepartments,
				showOnlyBannedPhones: selectedShowOnlyBannedPhones
			}, 
		} );
		return response.data;
	},

	getWhatsAppStatus: async () => {
		const response = await pipegoApi.get( '/sessions/status' );
		return response.data;
	},

	createSession: async ( phoneNumber = null ) => {
		const response = await pipegoApi.post( '/sub-sessions/add', {
			phoneNumber,
		} );
		return response.data;
	},

	logoutWhatsApp: async () => {
		const response = await pipegoApi.delete( '/sessions' );
		return response.data;
	},
	removeWithPhoneNumber: async ( phoneNumber ) => {
		const response = await pipegoApi.post( '/sub-sessions/delete-with-phone-number', {
			phoneNumber,
		} );
		return response.data;
	},

	updateOperator: async ( jid, operatorId, operatorEmail, caseId = undefined ) => {
		const response = await pipegoApi.put( `/chats/${jid}`, {
			negotiatorEmail : operatorEmail,
			negotiatorId    : operatorId,
			caseId,
		} );
		return response;
	},

	closeChatService: async ( jid ) => {
		const response = await pipegoApi.put( `/chats/${jid}/close` );
		return response;
	},

	refreshSubSession: async ( jid ) => {
		const response = await pipegoApi.put( `/chats/${jid}/sub-session` );
		return response;
	},

	updateChat: async ( payload ) => {
		const response = await pipegoApi.put( `/chats/${payload.id}`, payload );
		return response;
	},

	getTemplates: async ( payload ) => {
		const response = await pipegoApi.post( '/templates', payload );
		return response.data;
	},
	getPhoneNumbers: async () => {
		const response = await pipegoApi.get( '/sub-sessions' );
		return response.data;
	},

	togglePhoneNumberStatus: async ( subSessionId ) => {
		const response = await pipegoApi.post( `/sub-sessions/toggle-status`, {
			subSessionId,
		} );
		return response.data;
	},
	togglePhoneNumberJustReceptive: async ( subSessionId ) => {
		const response = await pipegoApi.post( `/sub-sessions/toggle-status-just-receptive`, {
			subSessionId,
		} );
		return response.data;
	},
	removeQrCodeGeneration: async ( subSessionId ) => {
		const response = await pipegoApi.post( `/sub-sessions/remove-qr-code-generation`, {
			subSessionId,
		} );
		return response.data;
	},
	getPairingCodeToPhoneCall: async ( subSessionId ) => {
		const response = await pipegoApi.post( `/calls/get-pairing-code-to-phone-call`, {
			subSessionId,
		} );
		return response.data;
	},
	disconnectPhoneCall: async ( subSessionId ) => {
		const response = await pipegoApi.post( `/calls/disconnect-phone-call`, {
			subSessionId,
		} );
		return response.data;
	}


};
